import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children, requireRole }) {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Chargement…</div>;
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (requireRole === 'admin' && !currentUser.isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
